import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { performancemaster } from './../../../../models/admin';
import { UtilityService } from './../../../../services/utility.service';
import { AdminApiService } from './../../../../services/admin.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from './../../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,   
  FilterCallbackArg,   
  OperatorString,
  MenuCallbackArgs

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../../toaster.service';

@Component({
  selector: 'app-performance-master',
  templateUrl: './performance-master.component.html',
  styleUrls: ['./performance-master.component.css']
})
export class PerformanceMasterComponent implements OnInit {
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  operatorList: OperatorString[] = ['=', '<', '<=', '>', '>=', '<>'];
  selectedOperator = '=';
  searchValue = '';
  selectedColumn: Column;
  modalRef: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  submitted: boolean = false;

  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  objPM: any = new performancemaster();
  angularGrid: AngularGridInstance;
  performanceMasterData: object[];
  selected_itemUno: number = 0;
    pfmType: any;
    isTitle: boolean=false;
    continentDDList: any=[];
    isContinentDD: boolean=false;
    titleName: string;
    Title2: boolean;
  countryDDList: any;
    isCountryDD: boolean=false;
    isRegionDD: boolean=false;
  sourceTypeDDList: any = [];
  regionDDList: any = [];
    isSourceTypeDD: boolean=false;
    isSourceDesc: boolean=false;
  utilityTypeDDList: any = [];
  peerTypeDDList: any = [];
  isUtilityTypeDD = false;
  isPeerTypeDD = false;
    isBusinessModel: boolean=false;
  isTechnologyUsed: boolean = false;
  masterTitle: string;
  user: any = {};
  login_UserID: string;
  isAdmin: boolean = false;
  public isBMChambion: boolean = false;
  public isBMTeam: boolean = false;
    dataSearch: any[];
    searchText: string;
    tenantUno: any;
  constructor(private formBuilder: FormBuilder, private toaster: ToasterService,public restApi: AdminApiService, private route: ActivatedRoute,
    public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    this.route.queryParams.subscribe((params: Params) => {
      let pfm = params['pfmtype'];
      this.pfmType = (pfm) ? pfm : '';
      this.searchText = '';
      

    });

    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission
  ValidateUserAccess() {
    
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;
    if (this.user.role == 'BM Champions')
      this.isBMChambion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;

    //Enable master(Source, Peer) for BM champions with read only access
    //Enable master(Source, Peer) for BM Team with read read / write access
    if (this.pfmType == 'source' || this.pfmType == 'peer') {
      if (!this.isAdmin && !this.isBMChambion && !this.isBMTeam)
        this.router.navigateByUrl('/access-denied');
    }
    else {

      if (!this.isAdmin)
        this.router.navigateByUrl('/access-denied');
    }

  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    
    this.route.queryParams.subscribe((params: Params) => {
      let pfm = params['pfmtype'];
      this.pfmType = (pfm) ? pfm : '';
      this.searchText = '';

      this.loadPerformanceMaster();
    });
   
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' ';

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' ';

  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      
      {
        id: 'titleNameEn', name: this.masterTitle, field: 'titleNameEn', sortable: true, type: FieldType.string, filterable: true, width: 300,
        filter: {
          collection: this.uniqueArray(this.dataset, 'titleNameEn', 'titleNameEn'),
          model: Filters.multipleSelect,

        }
      },
     
      
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                
                
                  let rdata: any = args.dataContext;
                  this.selTab = true;
                 
                this.objPM = this.performanceMasterData.filter((items: any) => items.id == rdata.id)[0];
                  
                  if (this.pageAction == 'edit') {
                    
                    this.selected_itemUno = rdata.id;
                  }
                  this.modalRef = this.modalService.show(
                    this.addtemplate,
                    Object.assign({}, {
                      class: 'gray modal-lg',
                      backdrop: true,
                      keyboard: true,
                      focus: true,
                      show: false,
                      ignoreBackdropClick: true,
                      animated: true
                    })
                  );
                
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeletePerformanceMaster(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }




    ]


  }


  setGridCountryDefn() {
    let temp = this;
    this.columnDefinitions = [

      {
        id: 'titleNameEn', name: 'Country', field: 'titleNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'titleNameEn', 'titleNameEn'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'continentNameEn', name: 'Continent', field: 'continentNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'continentNameEn', 'continentNameEn'),
          model: Filters.multipleSelect,
        },
       
      },
     
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.selTab = true;

                this.objPM = this.performanceMasterData.filter((items: any) => items.id == rdata.id)[0];

                if (this.pageAction == 'edit') {
                  
                  this.selected_itemUno = rdata.id;
                }
                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, { class: 'gray modal-lg' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeletePerformanceMaster(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }




    ]


  }

  setGridRegionDefn() {
    let temp = this;
    this.columnDefinitions = [

      {
        id: 'titleNameEn', name: 'Region', field: 'titleNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'titleNameEn', 'titleNameEn'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'continentNameEn', name: 'Continent', field: 'continentNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'continentNameEn', 'continentNameEn'),
          model: Filters.multipleSelect,
        },

      },
      {
        id: 'countryNameEn', name: 'Country', field: 'countryNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'countryNameEn', 'countryNameEn'),
          model: Filters.multipleSelect,
        },

      },


      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.selTab = true;

                this.objPM = this.performanceMasterData.filter((items: any) => items.id == rdata.id)[0];

                if (this.pageAction == 'edit') {
                  
                  this.selected_itemUno = rdata.id;
                }
                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, { class: 'gray modal-lg' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeletePerformanceMaster(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }




    ]


  }

  setGridSourceTypeDefn() {
    let temp = this;
    this.columnDefinitions = [

      {
        id: 'titleNameEn', name: 'Source Type', field: 'titleNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'titleNameEn', 'titleNameEn'),
          model: Filters.multipleSelect,

        }
      },
      
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.selTab = true;

                this.objPM = this.performanceMasterData.filter((items: any) => items.id == rdata.id)[0];

                if (this.pageAction == 'edit') {
                  
                  this.selected_itemUno = rdata.id;
                }
                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, { class: 'gray modal-lg' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeletePerformanceMaster(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }




    ]


  }

  setGridSourceDefn() {
    let temp = this;

    if (!this.isBMChambion) {
      this.columnDefinitions = [

        {
          id: 'titleNameEn', name: 'Source', field: 'titleNameEn', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'titleNameEn', 'titleNameEn'),
            model: Filters.multipleSelect,

          }
        },
        //{
        //  id: 'sourceDescription', name: 'Description', field: 'sourceDescription', sortable: true, type: FieldType.string, filterable: true, width: 50,
        //  filter: {
        //    collection: this.uniqueArray(this.dataset, 'sourceDescription', 'sourceDescription'),
        //    model: Filters.multipleSelect,

        //  }
        //},
        //{
        //  id: 'continentNameEn', name: 'Continent', field: 'continentNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
        //  filter: {
        //    collection: this.uniqueArray(this.dataset, 'continentNameEn', 'continentNameEn'),
        //    model: Filters.multipleSelect,
        //  },

        //},
        //{
        //  id: 'countryNameEn', name: 'Country', field: 'countryNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
        //  filter: {
        //    collection: this.uniqueArray(this.dataset, 'countryNameEn', 'countryNameEn'),
        //    model: Filters.multipleSelect,
        //  },

        //},
        {
          id: 'sourceTypeNameEn', name: 'Source Type', field: 'sourceTypeNameEn', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'sourceTypeNameEn', 'sourceTypeNameEn'),
            model: Filters.multipleSelect,
          },
        },
        //{
        //  id: 'regionNameEn', name: 'Region', field: 'regionNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
        //  filter: {
        //    collection: this.uniqueArray(this.dataset, 'regionNameEn', 'regionNameEn'),
        //    model: Filters.multipleSelect,
        //  },
        //},

        {
          id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
          excludeFromExport: true,
          formatter: this.actionFormatter,
          cellMenu: {
            hideCloseButton: false,
            commandTitleKey: 'COMMANDS',
            commandItems: [
              {
                command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
                iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
                action: (e, args) => {
                  this.pageAction = 'edit';
                  

                  let rdata: any = args.dataContext;
                  this.selTab = true;

                  this.objPM = this.performanceMasterData.filter((items: any) => items.id == rdata.id)[0];

                  if (this.pageAction == 'edit') {
                    
                    this.selected_itemUno = rdata.id;
                  }
                  this.modalRef = this.modalService.show(
                    this.addtemplate,
                    Object.assign({}, { class: 'gray modal-lg' })
                  );

                },
                // only show command to 'Delete Row' when the task is not completed

              },
              { divider: true, command: '', positionOrder: 63 },
              {
                command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
                iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
                itemVisibilityOverride: (args: MenuCallbackArgs) => {
                  if (this.isAdmin)
                    return true;
                  else false;
                },
                action: (e, args) => {
                  Swal.fire({
                    title: 'Delete',
                    text: 'Please confirm to delete the record',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ok',
                    cancelButtonText: 'Cancel'
                  }).then((result) => {
                    if (result.value) {
                      this.pageAction = 'delete';
                      this.DeletePerformanceMaster(args.dataContext);
                    } else if (result.dismiss === Swal.DismissReason.cancel) {

                    }
                  })
                },
                // only show command to 'Delete Row' when the task is not completed

              },


            ],
          }
        }

      ]
    }
    else {
      this.columnDefinitions = [

        {
          id: 'titleNameEn', name: 'Source', field: 'titleNameEn', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'titleNameEn', 'titleNameEn'),
            model: Filters.multipleSelect,

          }
        },
        
        {
          id: 'sourceTypeNameEn', name: 'Source Type', field: 'sourceTypeNameEn', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'sourceTypeNameEn', 'sourceTypeNameEn'),
            model: Filters.multipleSelect,
          },
        },
        

        //{
        //  id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
        //  excludeFromExport: true,
        //  formatter: this.actionFormatter,
        //  cellMenu: {
        //    hideCloseButton: false,
        //    commandTitleKey: 'COMMANDS',
        //    commandItems: [
        //      {
        //        command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
        //        iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
        //        action: (e, args) => {
        //          this.pageAction = 'edit';
        //          

        //          let rdata: any = args.dataContext;
        //          this.selTab = true;

        //          this.objPM = this.performanceMasterData.filter((items: any) => items.id == rdata.id)[0];

        //          if (this.pageAction == 'edit') {
        //            
        //            this.selected_itemUno = rdata.id;
        //          }
        //          this.modalRef = this.modalService.show(
        //            this.addtemplate,
        //            Object.assign({}, { class: 'gray modal-lg' })
        //          );

        //        },
        //        // only show command to 'Delete Row' when the task is not completed

        //      },
        //      { divider: true, command: '', positionOrder: 63 },
        //      {
        //        command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
        //        iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
        //        action: (e, args) => {
        //          Swal.fire({
        //            title: 'Delete',
        //            text: 'Please confirm to delete the record',
        //            type: 'warning',
        //            showCancelButton: true,
        //            confirmButtonText: 'Ok',
        //            cancelButtonText: 'Cancel'
        //          }).then((result) => {
        //            if (result.value) {
        //              this.pageAction = 'delete';
        //              this.DeletePerformanceMaster(args.dataContext);
        //            } else if (result.dismiss === Swal.DismissReason.cancel) {

        //            }
        //          })
        //        },
        //        // only show command to 'Delete Row' when the task is not completed

        //      },


        //    ],
        //  }
        //}

      ]
    }
  }

  setGridPeerDefn() {
    let temp = this;
    if (!this.isBMChambion) {
      this.columnDefinitions = [

        {
          id: 'titleNameEn', name: 'Peer', field: 'titleNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
          filter: {
            collection: this.uniqueArray(this.dataset, 'titleNameEn', 'titleNameEn'),
            model: Filters.multipleSelect,

          }
        },
        {
          id: 'peerTypeEn', name: 'Peer Type', field: 'peerTypeEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
          filter: {
            collection: this.uniqueArray(this.dataset, 'peerTypeEn', 'peerTypeEn'),
            model: Filters.multipleSelect,

          }
        },
        {
          id: 'countryNameEn', name: 'Country', field: 'countryNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
          filter: {
            collection: this.uniqueArray(this.dataset, 'countryNameEn', 'countryNameEn'),
            model: Filters.multipleSelect,
          },

        },
        {
          id: 'regionNameEn', name: 'Region', field: 'regionNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
          filter: {
            collection: this.uniqueArray(this.dataset, 'regionNameEn', 'regionNameEn'),
            model: Filters.multipleSelect,
          },
        },

        {
          id: 'continentNameEn', name: 'Continent', field: 'continentNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
          filter: {
            collection: this.uniqueArray(this.dataset, 'continentNameEn', 'continentNameEn'),
            model: Filters.multipleSelect,
          },

        },
        {
          id: 'utilityTypeEn', name: 'Utility Type', field: 'utilityTypeEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
          filter: {
            collection: this.uniqueArray(this.dataset, 'utilityTypeEn', 'utilityTypeEn'),
            model: Filters.multipleSelect,

          }
        },
        {
          id: 'businessModel', name: 'Utility Business', field: 'businessModel', sortable: true, type: FieldType.string, filterable: true, width: 50,
          filter: {
            collection: this.uniqueArray(this.dataset, 'businessModel', 'businessModel'),
            model: Filters.multipleSelect,

          }
        },

        //{
        //  id: 'technologyUsed', name: 'Technology Used', field: 'technologyUsed', sortable: true, type: FieldType.string, filterable: true, width: 50,
        //  filter: {
        //    collection: this.uniqueArray(this.dataset, 'technologyUsed', 'technologyUsed'),
        //    model: Filters.multipleSelect,

        //  }
        //},




        {
          id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
          excludeFromExport: true,
          formatter: this.actionFormatter,
          cellMenu: {
            hideCloseButton: false,
            commandTitleKey: 'COMMANDS',
            commandItems: [
              {
                command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
                iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
                action: (e, args) => {
                  this.pageAction = 'edit';
                  

                  let rdata: any = args.dataContext;
                  this.selTab = true;

                  this.objPM = this.performanceMasterData.filter((items: any) => items.id == rdata.id)[0];

                  if (this.pageAction == 'edit') {
                    
                    this.selected_itemUno = rdata.id;
                  }
                  this.modalRef = this.modalService.show(
                    this.addtemplate,
                    Object.assign({}, { class: 'gray modal-lg' })
                  );

                },
                // only show command to 'Delete Row' when the task is not completed

              },
              { divider: true, command: '', positionOrder: 63 },
              {
                command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
                iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
                itemVisibilityOverride: (args: MenuCallbackArgs) => {
                  

                  if (this.isAdmin)
                    return true;
                  else false;
                },
                action: (e, args) => {
                  Swal.fire({
                    title: 'Delete',
                    text: 'Please confirm to delete the record',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ok',
                    cancelButtonText: 'Cancel'
                  }).then((result) => {
                    if (result.value) {
                      this.pageAction = 'delete';
                      this.DeletePerformanceMaster(args.dataContext);
                    } else if (result.dismiss === Swal.DismissReason.cancel) {

                    }
                  })
                },
                // only show command to 'Delete Row' when the task is not completed

              },


            ],
          }
        }

      ]
    } else {
      this.columnDefinitions = [

        {
          id: 'titleNameEn', name: 'Peer', field: 'titleNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
          filter: {
            collection: this.uniqueArray(this.dataset, 'titleNameEn', 'titleNameEn'),
            model: Filters.multipleSelect,

          }
        },
        {
          id: 'peerTypeEn', name: 'Peer Type', field: 'peerTypeEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
          filter: {
            collection: this.uniqueArray(this.dataset, 'peerTypeEn', 'peerTypeEn'),
            model: Filters.multipleSelect,

          }
        },
        {
          id: 'countryNameEn', name: 'Country', field: 'countryNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
          filter: {
            collection: this.uniqueArray(this.dataset, 'countryNameEn', 'countryNameEn'),
            model: Filters.multipleSelect,
          },

        },
        {
          id: 'regionNameEn', name: 'Region', field: 'regionNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
          filter: {
            collection: this.uniqueArray(this.dataset, 'regionNameEn', 'regionNameEn'),
            model: Filters.multipleSelect,
          },
        },

        {
          id: 'continentNameEn', name: 'Continent', field: 'continentNameEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
          filter: {
            collection: this.uniqueArray(this.dataset, 'continentNameEn', 'continentNameEn'),
            model: Filters.multipleSelect,
          },

        },
        {
          id: 'utilityTypeEn', name: 'Utility Type', field: 'utilityTypeEn', sortable: true, type: FieldType.string, filterable: true, width: 50,
          filter: {
            collection: this.uniqueArray(this.dataset, 'utilityTypeEn', 'utilityTypeEn'),
            model: Filters.multipleSelect,

          }
        },
        {
          id: 'businessModel', name: 'Utility Business', field: 'businessModel', sortable: true, type: FieldType.string, filterable: true, width: 50,
          filter: {
            collection: this.uniqueArray(this.dataset, 'businessModel', 'businessModel'),
            model: Filters.multipleSelect,

          }
        },

      ]
    }
    
  }
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  searchGrid() {
    if (this.pfmType == "continent" || this.pfmType == "sourcetype" || this.pfmType == "utilitytype" || this.pfmType == "peertype" || this.pfmType == "consideration" || this.pfmType == "position" || this.pfmType == "regulator" || this.pfmType == "council") {
      if (this.searchText != "") {
        this.dataset = this.dataSearch.filter(a =>
          a.titleNameEn && a.titleNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          );
      }
      else {
        this.dataset = this.dataSearch;
      }
    }
    else if (this.pfmType == "country") {
      if (this.searchText != "") {
        this.dataset = this.dataSearch.filter(a =>
          a.titleNameEn && a.titleNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.continentNameEn && a.continentNameEn.toLowerCase().includes(this.searchText.toLowerCase())
        );
      }
      else {
        this.dataset = this.dataSearch;
      }
    }

    else if (this.pfmType == "region") {
      if (this.searchText != "") {
        this.dataset = this.dataSearch.filter(a =>
          a.titleNameEn && a.titleNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.continentNameEn && a.continentNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.countryNameEn && a.countryNameEn.toLowerCase().includes(this.searchText.toLowerCase())
        );
      }
      else {
        this.dataset = this.dataSearch;
      }
    }
    else if (this.pfmType == "source") {
      if (this.searchText != "") {
        this.dataset = this.dataSearch.filter(a =>
          a.titleNameEn && a.titleNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.continentNameEn && a.continentNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.countryNameEn && a.countryNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.regionNameEn && a.regionNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.sourceTypeNameEn && a.sourceTypeNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.sourceDescription && a.sourceDescription.toLowerCase().includes(this.searchText.toLowerCase())
        );
      }
      else {
        this.dataset = this.dataSearch;
      }
    }
    else if (this.pfmType == "peer") {
      if (this.searchText != "") {
        this.dataset = this.dataSearch.filter(a =>
          a.titleNameEn && a.titleNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.continentNameEn && a.continentNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.countryNameEn && a.countryNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.regionNameEn && a.regionNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.sourceTypeNameEn && a.sourceTypeNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.technologyUsed && a.technologyUsed.toLowerCase().includes(this.searchText.toLowerCase())
          || a.businessModel && a.businessModel.toLowerCase().includes(this.searchText.toLowerCase())
          || a.regionNameEn && a.regionNameEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.utilityTypeEn && a.utilityTypeEn.toLowerCase().includes(this.searchText.toLowerCase())
          || a.peerTypeEn && a.peerTypeEn.toLowerCase().includes(this.searchText.toLowerCase())
        );
      }
      else {
        this.dataset = this.dataSearch;
      }
    }
  }
  loadPerformanceMaster() {
    this.spinner.show();
    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tableName = this.pfmType;
    
    this.restApi.getPerformanceMaster(inpValue)
      .subscribe(data => {
        
       
        this.data = uniqBy(data, 'id');
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {
          if (this.pfmType == "continent") {
            
            mockDataset[i] = {
              id: this.data[i].id,
              titleNameEn: this.data[i].titleNameEn
            };
          }
          else if (this.pfmType == "country") {
            mockDataset[i] = {
              id: this.data[i].id,
              titleNameEn: this.data[i].titleNameEn,
              continentUno: this.data[i].continentUno,
              continentNameEn: this.data[i].continentNameEn

            };
          }
          else if (this.pfmType == "region") {
            mockDataset[i] = {
              id: this.data[i].id,
              titleNameEn: this.data[i].titleNameEn,
              continentUno: this.data[i].continentUno,
              continentNameEn: this.data[i].continentNameEn,
              countryUno: this.data[i].countryUno,
              countryNameEn: this.data[i].countryNameEn

            };
          }
          else if (this.pfmType == "sourcetype") {
            mockDataset[i] = {
              id: this.data[i].id,
              titleNameEn: this.data[i].titleNameEn
            };
          }
          else if (this.pfmType == "source") {
            mockDataset[i] = {
              id: this.data[i].id,
              titleNameEn: this.data[i].titleNameEn,
              sourceDescription: this.data[i].sourceDescription,
              continentUno: this.data[i].continentUno,
              continentNameEn: this.data[i].continentNameEn,
              countryUno: this.data[i].countryUno,
              countryNameEn: this.data[i].countryNameEn,
              regionUno: this.data[i].regionUno,
              regionNameEn: this.data[i].regionNameEn,
              sourceTypeUno: this.data[i].sourceTypeUno,
              sourceTypeNameEn: this.data[i].sourceTypeNameEn
            };
          }
          else if (this.pfmType == "utilitytype") {
            mockDataset[i] = {
              id: this.data[i].id,
              titleNameEn: this.data[i].titleNameEn
            };
          }
          else if (this.pfmType == "peertype") {
            mockDataset[i] = {
              id: this.data[i].id,
              titleNameEn: this.data[i].titleNameEn
            };
          }
          else if (this.pfmType == "peer") {
            mockDataset[i] = {
              id: this.data[i].id,
              titleNameEn: this.data[i].titleNameEn,
              continentUno: this.data[i].continentUno,
              continentNameEn: this.data[i].continentNameEn,
              technologyUsed: this.data[i].technologyUsed,
              businessModel: this.data[i].businessModel,
              countryUno: this.data[i].countryUno,
              countryNameEn: this.data[i].countryNameEn,
              regionUno: this.data[i].regionUno,
              regionNameEn: this.data[i].regionNameEn,
              sourceTypeUno: this.data[i].sourceTypeUno,
              sourceTypeNameEn: this.data[i].sourceTypeNameEn,
              utilityTypeUno: this.data[i].utilityTypeUno,
              utilityTypeEn: this.data[i].utilityTypeEn,
              peerTypeUno: this.data[i].peerTypeUno,
              peerTypeEn: this.data[i].peerTypeEn
            };
          }
          else if (this.pfmType == "consideration") {
            mockDataset[i] = {
              id: this.data[i].id,
              titleNameEn: this.data[i].titleNameEn
            };
          }
          else if (this.pfmType == "position") {
            mockDataset[i] = {
              id: this.data[i].id,
              titleNameEn: this.data[i].titleNameEn
            };
          }
          else if (this.pfmType == "regulator") {
            mockDataset[i] = {
              id: this.data[i].id,
              titleNameEn: this.data[i].titleNameEn
            };
          }
          else if (this.pfmType == "council") {
            mockDataset[i] = {
              id: this.data[i].id,
              titleNameEn: this.data[i].titleNameEn
            };
          }
          else if (this.pfmType == "strategic objective") {
            mockDataset[i] = {
              id: this.data[i].id,
              titleNameEn: this.data[i].titleNameEn
            };
          } 
          else if (this.pfmType == "strategic priority") {
            mockDataset[i] = {
              id: this.data[i].id,
              titleNameEn: this.data[i].titleNameEn
            };
          }

        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          if (this.pfmType == "continent") {
            this.isTitle = true;
            this.isContinentDD = false;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.titleName = "Continent Name";
            this.masterTitle = "Continent";

            this.setColnDefn();
          }
          else if (this.pfmType == "strategic objective") {
            this.isTitle = true;
            this.isContinentDD = false;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.titleName = "Strategic Objective Name";
            this.masterTitle = "Strategic Objective";
            this.setColnDefn();
          }
          else if (this.pfmType == "strategic priority") {
            this.isTitle = true;
            this.isContinentDD = false;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.titleName = "Strategic Priority Name";
            this.masterTitle = "Strategic Priority";
            this.setColnDefn();
          }
          else if (this.pfmType == "country") {
            this.titleName = "Country Name";
            this.masterTitle = "Country";
            this.isTitle = true;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isContinentDD = true;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.getContinentDD();
            this.setGridCountryDefn();
          }
          else if (this.pfmType == "region") {

            this.titleName = "Region Name";
            this.masterTitle = "Region";
            this.isTitle = true;
            this.isCountryDD = true;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isContinentDD = true;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.getContinentDD();
            this.getCountryDD();
            this.setGridRegionDefn();
          }
          else if (this.pfmType == "sourcetype") {
            this.titleName = "Source Type Name";
            this.masterTitle = "Source Type";
            this.isTitle = true;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isContinentDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.setGridSourceTypeDefn();
          }
          else if (this.pfmType == "source") {
            this.isContinentDD = true;
            this.titleName = "Source Name";
            this.masterTitle = "Source";
            this.isTitle = true;
            this.isCountryDD = true;
            this.isRegionDD = true;
            this.isSourceTypeDD = true;
            this.isSourceDesc = true;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.getRegionDD();
            this.getContinentDD();
            this.getCountryDD();
            this.getSourceTypeDD();
            this.setGridSourceDefn();
          }
          else if (this.pfmType == "utilitytype") {
            this.isContinentDD = false;
            this.titleName = "Utility Type Name";
            this.masterTitle = "Utility Type";
            this.isTitle = true;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.setColnDefn();
          }
          else if (this.pfmType == "peertype") {
            this.isContinentDD = false;
            this.titleName = "Peer Type Name";
            this.masterTitle = "Peer Type";
            this.isTitle = true;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.setColnDefn();
          }
          else if (this.pfmType == "peer") {
            this.titleName = "Peer Name";
            this.masterTitle = "Peer";
            this.isTitle = true;
            this.isCountryDD = true;
            this.isRegionDD = true;
            this.isSourceTypeDD = false;
            this.isContinentDD = true;
            this.isUtilityTypeDD = true;
            this.isPeerTypeDD = true;
            this.isSourceDesc = false;
            this.isBusinessModel = true;
            this.isTechnologyUsed = true;
            this.getUtilityTypeDD();
            this.getPeerTypeDD();
            this.getRegionDD();
            this.getContinentDD();
            this.getCountryDD();
            this.setGridPeerDefn();
          }
          else if (this.pfmType == "consideration") {
            this.isTitle = true;
            this.isContinentDD = false;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.titleName = "Consideration Name";
            this.masterTitle = "Consideration";
            this.setColnDefn();
          }
          else if (this.pfmType == "position") {
            this.isTitle = true;
            this.isContinentDD = false;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.titleName = "Position Name";
            this.masterTitle = "Position";
            this.setColnDefn();
          }
          else if (this.pfmType == "regulator") {
            this.isTitle = true;
            this.isContinentDD = false;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.titleName = "Regulator Name";
            this.masterTitle = "Regulator";
            this.setColnDefn();
          }
          else if (this.pfmType == "council") {
            this.isTitle = true;
            this.isContinentDD = false;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.titleName = "Council Name";
            this.masterTitle = "Council";
            this.setColnDefn();
          }
        }
        else {
          if (this.pfmType == "continent") {
            this.isTitle = true;
            this.isContinentDD = false;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.titleName = "Continent Name";
            this.masterTitle = "Continent";

            this.setColnDefn();
          }
          else if (this.pfmType == "country") {
            this.titleName = "Country Name";
            this.masterTitle = "Country";
            this.isTitle = true;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isContinentDD = true;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.getContinentDD();
            this.setGridCountryDefn();
          }
          else if (this.pfmType == "region") {

            this.titleName = "Region Name";
            this.masterTitle = "Region";
            this.isTitle = true;
            this.isCountryDD = true;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isContinentDD = true;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.getContinentDD();
            this.getCountryDD();
            this.setGridRegionDefn();
          }
          else if (this.pfmType == "sourcetype") {
            this.titleName = "Source Type Name";
            this.masterTitle = "Source Type";
            this.isTitle = true;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isContinentDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.setGridSourceTypeDefn();
          }
          else if (this.pfmType == "source") {
            this.isContinentDD = true;
            this.titleName = "Source Name";
            this.masterTitle = "Source";
            this.isTitle = true;
            this.isCountryDD = true;
            this.isRegionDD = true;
            this.isSourceTypeDD = true;
            this.isSourceDesc = true;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.getRegionDD();
            this.getContinentDD();
            this.getCountryDD();
            this.getSourceTypeDD();
            this.setGridSourceDefn();
          }
          else if (this.pfmType == "utilitytype") {
            this.isContinentDD = false;
            this.titleName = "Utility Type Name";
            this.masterTitle = "Utility Type";
            this.isTitle = true;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.setColnDefn();
          }
          else if (this.pfmType == "peertype") {
            this.isContinentDD = false;
            this.titleName = "Peer Type Name";
            this.masterTitle = "Peer Type";
            this.isTitle = true;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.setColnDefn();
          }
          else if (this.pfmType == "peer") {
            this.titleName = "Peer Name";
            this.masterTitle = "Peer";
            this.isTitle = true;
            this.isCountryDD = true;
            this.isRegionDD = true;
            this.isSourceTypeDD = false;
            this.isContinentDD = true;
            this.isUtilityTypeDD = true;
            this.isPeerTypeDD = true;
            this.isSourceDesc = false;
            this.isBusinessModel = true;
            this.isTechnologyUsed = true;
            this.getUtilityTypeDD();
            this.getPeerTypeDD();
            this.getRegionDD();
            this.getContinentDD();
            this.getCountryDD();
            this.setGridPeerDefn();
          }
          else if (this.pfmType == "consideration") {
            this.isTitle = true;
            this.isContinentDD = false;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.titleName = "Consideration Name";
            this.masterTitle = "Consideration";
            this.setColnDefn();
          }
          else if (this.pfmType == "position") {
            this.isTitle = true;
            this.isContinentDD = false;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.titleName = "Position Name";
            this.masterTitle = "Position";
            this.setColnDefn();
          }
          else if (this.pfmType == "regulator") {
            this.isTitle = true;
            this.isContinentDD = false;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.titleName = "Regulator Name";
            this.masterTitle = "Regulator";
            this.setColnDefn();
          }
          else if (this.pfmType == "council") {
            this.isTitle = true;
            this.isContinentDD = false;
            this.isCountryDD = false;
            this.isRegionDD = false;
            this.isSourceTypeDD = false;
            this.isSourceDesc = false;
            this.isPeerTypeDD = false;
            this.isUtilityTypeDD = false;
            this.isBusinessModel = false;
            this.isTechnologyUsed = false;
            this.titleName = "Council Name";
            this.masterTitle = "Council";
            this.setColnDefn();
          }
         
        }
        this.performanceMasterData = mockDataset;
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  openModalWithClass(addtemplate: TemplateRef<any>) {
    
    this.pageAction = "add";
    this.objPM = new performancemaster();
    
    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  onSubmit(val1) {
    
    if (!val1) {
      //Swal.fire('Error', 'Please enter the required information.', 'error');
      this.toaster.show('error', 'Error', 'Please enter the required information.');

      return
    }
    
    else {
      this.AddEditPerformanceMaster(this.objPM)
    }
  }

  AddEditPerformanceMaster(data1: any) {
    
    //if (this.kpiForm.invalid) {
    //  Swal.fire('Error', 'Something went wrong!', 'error')
    //  return false;
    //}


    if (this.DuplicateNameCheck(this.utilityService.isNumericNull(data1.id), this.utilityService.isStringNull(data1.titleNameEn), this.utilityService.isStringNull(data1.titleNameAr))) {
      //Swal.fire('Error', 'Duplicates are not allowed', 'warning');
      this.toaster.show('warning', 'Warning', 'Duplicates are not allowed');
      return false;
    }
    else {

      let objPF = new performancemaster();
      objPF = data1;
      objPF.titleNameEn = (objPF.titleNameEn) ? objPF.titleNameEn.toString() : '';
      objPF.sourceDescription = (objPF.sourceDescription) ? objPF.sourceDescription.toString() : '';
      objPF.businessModel = (objPF.businessModel) ? objPF.businessModel.toString() : '';
      objPF.technologyUsed = (objPF.technologyUsed) ? objPF.technologyUsed.toString() : '';
      objPF.continentUno = objPF.continentUno;
      objPF.countryUno = objPF.countryUno;
      objPF.regionUno = objPF.regionUno;
      objPF.sourceTypeUno = objPF.sourceTypeUno;
      objPF.userUno = this.login_UserID;
      objPF.condition = (this.pageAction == "add") ? 0 : 1;
      objPF.tenantUno = this.tenantUno;
      objPF.tableName = this.pfmType;
      this.restApi.addEditPerformanceMaster(objPF)
        .subscribe(data => {

          if (data != null && data != undefined && data != '') {
           // Swal.fire('Error', 'Something went wrong', 'error');
            this.toaster.show('error', 'Error', 'Something went wrong');
            this.spinner.hide();
          }
          else {
            //Swal.fire({type: 'success',title: 'Item saved.',showConfirmButton: false,timer: 1500 })
            this.toaster.show('success', 'Success', 'Item saved.');
            setTimeout(() => {
              this.objPM = new performancemaster();
              this.spinner.hide();
              this.loadPerformanceMaster();
              this.modalRef.hide();
            }, 500);

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
    }
  }
  DuplicateNameCheck(itemUno: number, nameEn: string, nameAr: string) {
    
    if (this.data != null && this.data != undefined) {
      var rtnValue = false;
      this.data.forEach((grdData) => {
        if (((itemUno != grdData.id) || (itemUno == grdData.id && this.selected_itemUno != grdData.id))
          &&
          (grdData.titleNameEn.toLocaleLowerCase() == nameEn.trim().toLowerCase())) {
          rtnValue = true;
        }
       
        

      });

      return rtnValue;
    }
  }


  DeletePerformanceMaster(data1: any) {
    
    let objpfm = new performancemaster();
    objpfm.actionType = this.pageAction;
    objpfm.id = data1.id;
    objpfm.userUno = this.login_UserID;
    objpfm.tenantUno = this.tenantUno;
    objpfm.tableName = this.pfmType;
    this.restApi.deletePerformanceMaster(objpfm)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
         // Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {

          //Swal.fire({type: 'success',title: 'Item deleted.', showConfirmButton: false, timer: 1500})
          this.toaster.show('success', 'Success', 'Item deleted.');
          this.loadPerformanceMaster();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }


  getContinentDD() {

    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.GetContinentDD(inpValue)
      .subscribe(data => {

        this.continentDDList = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

    getCountryDD() {

      let inpValue = new performancemaster();
      inpValue.languageUno = 1033;
      inpValue.itemUno = 0;
      inpValue.condition = 1;
      inpValue.tenantUno = this.tenantUno;
      inpValue.userUno = this.login_UserID;
      this.restApi.GetCountryDD(inpValue)
        .subscribe(data => {

          this.countryDDList = data;
        },
          (error) => {
            //Called when error
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
        });
  }
  getRegionDD() {

    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.GetRegionDD(inpValue)
      .subscribe(data => {
        this.regionDDList = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getSourceTypeDD() {

    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.GetSourceTypeDD(inpValue)
      .subscribe(data => {
        this.sourceTypeDDList = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getUtilityTypeDD() {

    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.GetUtilityTypeDD(inpValue)
      .subscribe(data => {
        this.utilityTypeDDList = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

  }
    getPeerTypeDD() {

      let inpValue = new performancemaster();
      inpValue.languageUno = 1033;
      inpValue.itemUno = 0;
      inpValue.condition = 1;
      inpValue.tenantUno = this.tenantUno;
      inpValue.userUno = this.login_UserID;
      this.restApi.GetPeerTypeDD(inpValue)
        .subscribe(data => {
          this.peerTypeDDList = data;
        },
          (error) => {
            //Called when error
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
        });
    }
  Reset() {
    this.modalRef.hide();
    setTimeout(() => {
    this.objPM = new performancemaster();
      this.pageAction = 'add'; }, 300);
   
    
  }

  updateSearchFilter(searchtext) {
    
    this.searchValue = searchtext;
    this.selectedColumn = this.columnDefinitions[0];
    if (this.selectedColumn && this.selectedOperator) {
      const fieldName = this.selectedColumn.field;
      const filter = {};
      const filterArg: FilterCallbackArg = {
        columnDef: this.selectedColumn,
        operator: this.selectedOperator as OperatorString, // or fix one yourself like '='
        searchTerms: [this.searchValue || '']
      };

      if (this.searchValue) {
        // pass a columnFilter object as an object which it's property name must be a column field name (e.g.: 'duration': {...} )
        filter[fieldName] = filterArg;
      }

      this.angularGrid.dataView.setFilterArgs({
        columnFilters: filter,
        grid: this.angularGrid.slickGrid
      });
      this.angularGrid.dataView.refresh();
    }
   
  }
}
